<!-- This component has been built by following the guidelines from the dawa documentation
        https://dawa.aws.dk/dok/api/autocomplete#autocomplete
    -->

<template>
    <div class="col-md-12">
        <div class="form-group">
            <div class="input dawa-wrapper">
                <input type="text" v-bind:readonly="addressFound" v-bind="validationAttributes" v-bind:data-val-street="street" v-bind:data-val-city="city" v-bind:data-val-zipcode="zipCode" inputmode="text" placeholder="Adresse" v-bind:id="labelName" v-bind:name="labelName" class="form-control" :autocomplete="autocomplete" v-model="inputValue" ref="DawaAddress" />
                <label v-bind:for="labelName">{{ labelText }}</label>
                <slot /> <!-- To insert validation span if needed -->
                <div class="dawa-list" v-if="searchResults && !addressFound && inputValue">
                    <ul>
                        <li v-for="(item, index) in searchResults" :key="index" v-on:click="setSuggestion(item)">{{ $filters.formatAddress(item.suggestionText) }}</li>
                    </ul>
                </div>

                <button class="dawa-clear" type="button" v-on:click="clearInput" v-if="addressFound">
                    <svg focusable="false" width="24" height="24" viewBox="0 0 24 24">
                        <use href="/ui/icons/custom-sprite.svg#icon-close-dark" />
                    </svg>
                </button>
            </div>

            <!-- hidden fields needed to model bind to view model with mvc -->
            <input type="hidden" v-bind:name="streetName" v-bind:value="street" placeholder="Vejnavn" class="form-control" />
            <input type="hidden" v-bind:name="zipCodeName" v-bind:value="zipCode" placeholder="Postnummer" class="form-control" />
            <input type="hidden" v-bind:name="cityName" v-bind:value="city" placeholder="By" class="form-control" />
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: 'dawa-address',
        props: {
            labelName: {
                type: String,
                default: 'DawaAddress'
            },
            labelText: {
                type: String,
                default: 'Find Adresse'
            },
            streetName: {
                type: String,
                default: 'Street'
            },
            zipCodeName: {
                type: String,
                default: 'ZipCode'
            },
            cityName: {
                type: String,
                default: 'City'
            },
            errorMessage: {
                type: String,
                default: 'Indtast adresse'
            },
            validationAttributes: {
                type: Object
            }
        },
        data() {
            return {
                street: undefined,
                zipCode: undefined,
                city: undefined,
                inputValue: undefined,
                searchResults: undefined,
                rawData: undefined,
                options: {
                    per_side: 6,
                    fuzzy: "",
                    type: "adresse",
                    caretpos: 0,
                    supplerendebynavn: true,
                    stormodtagerpostnumre: true,
                    multilinje: true
                },
                selected: undefined
            }
        },
        computed: {
            addressFound: function () {
                if (this.selected == undefined) {
                    return false;
                }

                return this.selected.type === 'adresse';
            },
            paramOptions: function () {
                if (this.selected !== undefined) {
                    if (this.selected.type == "vejnavn") {
                        this.options.startfra = "adgangsadresse"
                    }

                    if (this.selected.type == "adgangsadresse") {
                        this.options.startfra = "adresse"
                    }

                    this.options.caretpos = this.selected.caretpos;

                } else {
                    this.options.startfra = "vejnavn";
                }

                return this.options;
            },
            autocomplete: function () {
                let value = "can-be-anything";
                if (this.isBrowserFireFox()) {
                    value = "off";
                }

                return value;
            }
        },
        methods: {
            isBrowserFireFox: function () {
                return typeof InstallTrigger !== 'undefined'
            },
            setSuggestion: function (value) {
                this.selected = value;
                this.inputValue = this.selected.inputText;

                if (this.selected.type == 'adresse') {
                    this.setCompletedAddress(this.selected.data);
                    this.validateField();
                }
            },
            searchAddress: function (input) {
                this.paramOptions.q = input;
                axios.get("https://dawa.aws.dk/autocomplete", {
                    params: this.paramOptions
                }).then(response => {
                    this.searchResults = response.data.map(elem => ({
                        type: elem.type,
                        inputText: elem.tekst,
                        caretpos: elem.caretpos,
                        suggestionText: elem.forslagstekst,
                        data: elem.data
                    }));
                    this.rawData = response;
                    this.determineFinalAddress(response.data);
                }).catch(error => {

                });
            },
            clearInput: function () {
                this.inputValue = undefined;
                this.city = undefined;
                this.zipCode = undefined;
                this.street = undefined;
                this.selected = undefined;
            },
            setCompletedAddress: function (searchResult) {
                var vm = this;

                var door = searchResult.dør;
                var floor = searchResult.etage;
                var streetName = searchResult.vejnavn;
                var houseNumber = searchResult.husnr;
                var city = searchResult.postnrnavn;
                var supCity = searchResult.supplerendebynavn;
                var zip = searchResult.postnr;

                var fullStreetName = `${streetName} ${houseNumber}`;
                if (floor) {
                    fullStreetName += `${floor ? ', ' + floor + '.' : ''}${supCity ? ', ': ''}${door ? door : (supCity ?? '')}`;
                }

                vm.street = fullStreetName;
                vm.zipCode = zip;
                vm.city = city;
            },
            determineFinalAddress: function (searchResults) {
                //when search results are only 1, we check if the result is of type "adresse".
                if (searchResults.length === 1) {
                    var possibleAddress = searchResults[0];

                    if (possibleAddress.type == "adresse") {
                        //when 1 result remain we auto pick it
                        this.selected = possibleAddress;
                        this.inputValue = possibleAddress.tekst;
                        this.setCompletedAddress(possibleAddress.data);
                        this.validateField();
                    }
                }
            },
            validateField: function () { //triggers unobtrusive validation
                this.$refs.DawaAddress.blur(); //lose focus
                this.$refs.DawaAddress.focus(); //set focus on input field
            }
        },
        watch: {
            inputValue: function (value) {
                this.paramOptions.caretpos = this.$refs.DawaAddress.selectionStart;

                this.searchAddress(value);
            }
        }
    }
</script>